/* Belvoir exclusive: first-view swipe hint, cancelable on user interaction. */
(() => {
  if (window.__belvoirExclusiveIntroInstalled) return;
  window.__belvoirExclusiveIntroInstalled = true;

  const controllers = new WeakMap();
  const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
  const ease = (t) => t * t * (3 - 2 * t);

  function setup(section) {
    if (controllers.has(section)) return;
    const stage = section.querySelector('.bv-comparison__stage');
    const slider = stage?.querySelector('input[type="range"]');
    if (!stage || !slider) return;

    const state = { stopped: false, frame: 0, observer: null };
    controllers.set(section, state);
    const origin = clamp(Number(slider.value) || 50, 0, 100);
    const distance = clamp(Number(section.dataset.bvExclusiveAmplitude) || 20, 5, 35);
    const duration = clamp(Number(section.dataset.bvExclusiveDuration) || 2000, 650, 4000);
    const setSplit = (value) => {
      const v = clamp(value, 0, 100);
      stage.style.setProperty('--split', v.toFixed(2) + '%');
      slider.value = String(Math.round(v));
    };
    const stop = () => {
      state.stopped = true;
      cancelAnimationFrame(state.frame);
      state.observer?.disconnect();
    };
    slider.addEventListener('pointerdown', stop, { passive: true });
    slider.addEventListener('touchstart', stop, { passive: true });
    slider.addEventListener('keydown', stop);
    slider.addEventListener('input', stop);

    if (section.dataset.bvExclusiveIntro !== 'true' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const frames = [
      [0, origin],
      [.29, clamp(origin + distance, 5, 95)],
      [.65, clamp(origin - distance, 5, 95)],
      [.86, clamp(origin + distance * .26, 5, 95)],
      [1, origin]
    ];
    const play = () => {
      if (state.stopped) return;
      let started = null;
      function tick(now) {
        if (state.stopped) return;
        if (started === null) started = now;
        const t = Math.min(1, (now - started) / duration);
        let value = origin;
        for (let i = 1; i < frames.length; i++) {
          if (t <= frames[i][0]) {
            const [fromTime, fromValue] = frames[i - 1];
            const [toTime, toValue] = frames[i];
            value = fromValue + (toValue - fromValue) * ease((t - fromTime) / (toTime - fromTime));
            break;
          }
        }
        setSplit(value);
        if (t < 1) state.frame = requestAnimationFrame(tick);
        else {
          setSplit(origin);
          state.stopped = true;
        }
      }
      state.frame = requestAnimationFrame(tick);
    };

    if (!('IntersectionObserver' in window)) {
      play();
      return;
    }
    state.observer = new IntersectionObserver((entries) => {
      if (!entries.some(e => e.isIntersecting && e.intersectionRatio >= .18)) return;
      state.observer.disconnect();
      play();
    }, { threshold: [.18, .35] });
    state.observer.observe(stage);
  }

  const init = root => {
    if (root?.matches?.('.bv-comparison')) setup(root);
    root?.querySelectorAll?.('.bv-comparison').forEach(setup);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll?.('.bv-comparison').forEach(section => {
      const state = controllers.get(section);
      if (state) {
        state.stopped = true;
        cancelAnimationFrame(state.frame);
        state.observer?.disconnect();
        controllers.delete(section);
      }
    });
  });
})();
